module.exports = __webpack_public_path__ + "img/gallerypic_sp.c44f9d0c.png";